import BaseWebSocketHandler from "./BaseWebSocketHandler";

class AlertWebSocketHandler extends BaseWebSocketHandler {
  constructor() {
    const baseUrl =
      process.env.REACT_APP_ALERT_WS_URL || "ws://localhost:8000/ws/alert_logs";

    const parserFn = (rawSocketData) => {
      try {
        const parsed = JSON.parse(rawSocketData);
        return {
          type: "alert_notification",
          deviceId: parsed.device_id,
          priority: parsed?.priority || null,
          field: parsed.field,
          value: parsed.value,
          alertType: parsed.alert_type,
          triggerMessage: parsed.trigger_message,
          recipients: parsed.recipients || [],
          timestamp: parsed.timestamp,
        };
      } catch (err) {
        return {
          type: "parse_error",
          raw: rawSocketData,
          error: err.message,
        };
      }
    };

    super(baseUrl, parserFn);
  }
}

const alertWebSocketHandler = new AlertWebSocketHandler();
export default alertWebSocketHandler;